"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABSENCE_POOLS = void 0;
exports.readPool = readPool;
exports.poolFlags = poolFlags;
exports.poolLabel = poolLabel;
/**
 * Pula, z której schodzi typ nieobecności.
 *
 * Trzy flagi w bazie są ROZŁĄCZNE - kontroler urlopów sprawdza dostępne dni względem
 * jednej puli, a salda roczne sumują każdą flagę osobno, więc typ z dwiema flagami
 * zjadałby dwie pule naraz. Backend odrzuca taki payload, a UI nie daje go nawet złożyć:
 * zamiast trzech niezależnych przełączników jest jeden wybór.
 */
exports.ABSENCE_POOLS = [
    { value: "limit", label: "Limit urlopu" },
    { value: "care", label: "Pula opieki" },
    { value: "holiday", label: "Pula wolnego za święta" },
    { value: "none", label: "Żadna - nie zmniejsza żadnej puli" },
];
/** Kolejność jak w kontrolerze urlopów (assertTypeWithinPool): opieka, za święta, limit. */
function readPool(type) {
    if (type.countsAsCare)
        return "care";
    if (type.countsAsHoliday)
        return "holiday";
    if (type.countsAgainstLimit)
        return "limit";
    return "none";
}
/** Wybór z listy → trzy flagi payloadu. Z definicji najwyżej jedna jest prawdziwa. */
function poolFlags(pool) {
    return {
        countsAgainstLimit: pool === "limit",
        countsAsCare: pool === "care",
        countsAsHoliday: pool === "holiday",
    };
}
function poolLabel(type) {
    const pool = readPool(type);
    return exports.ABSENCE_POOLS.find((p) => p.value === pool).label;
}
